// Week.tsx
import { eachDayOfInterval, format, isToday, addDays } from 'date-fns'
import { css } from '../../styles/stitches.config'
import { Day, Header } from '../../styles/timeline/week.style'
import { formatDateRange, now } from '../../utils'

interface WeekProps {
  start: Date
  week: number
  showDates?: boolean
}

export const Week = ({ start, week, showDates = true }: WeekProps) => {
  // Create an interval from Monday (start) to Sunday.
  const weekDays = eachDayOfInterval({ start, end: addDays(start, 6) })

  return (
    <div
      className="week-container"
      style={{
        // width: '47rem', // Updated from 15rem to 45rem.
        width: '100%',
        gap: '0.5rem',
        display: 'flex',
        flexDirection: 'column',
      }}
    >


      <div style={{ display: 'flex' }}>
        {weekDays.map((day, i) => (
          <Day key={i} active={isToday(day)}>
            {format(day, 'ccc')}
          </Day>
        ))}
      </div>

      {showDates && (
      <div style={{ display: 'flex' }}>
        {weekDays.map((day, i) => (
          <Day
            key={i}
            active={isToday(day)}
            className={css({ color: '$neutral8', fontSize: '$sm' })()}
          >
            {day.getDate()}
          </Day>
        ))}
      </div>
      )}
    </div>
  )
}